export class Timer {
	constructor(
		public duration: number,
		public onTick: (remainingTime: number) => void,
		public onComplete: () => void
	) {}

	private remainingTime: number = this.duration;
	private intervalId: NodeJS.Timeout;

	async start() {
		this.onTick(this.remainingTime);
		this.intervalId = setInterval(() => {
			this.remainingTime -= 1000;
			if (this.remainingTime <= 0) {
				this.stop();
				this.onComplete();
			} else {
				this.onTick(this.remainingTime);
			}
		}, 1000);
	}

	stop() {
		clearInterval(this.intervalId);
		this.remainingTime = this.duration;
	}

	reset() {
		this.stop();
		this.start();
	}
}
